module.exports = __webpack_public_path__ + "img/中国总公司.16b0e9d3.png";